const custom_colors = [
  '#CC0000',
  '#990000',
  '#9BC3D3',
  '#CEDEE7',
  '#444444',
  '#1BB3BC',
  '#FFCC33',
  '#9E3667',
  '#63BA68',
  '#3366FF',
  '#1C7E82',
  '#926E15',
  '#722745',
  '#3D8143',
  '#0B3CE1',
  '#7BD1D5',
  '#FDDF8A',
  '#C387A3',
  '#A2D4A6',
  '#85A5FB',
]

const low_colors = [
  '#CC0000',
  '#1BB3BC',
  '#9E3667',
  '#9BC3D3',
  '#FFCC33',
  '#63BA68',
  '#3366FF',
  '#444444',
]
const low_colors_dark = [
  '#FF6161',
  '#22CFD8',
  '#bc5478',
  '#84C0ff',
  '#FFD684',
  '#8cce80',
  '#5a85ff',
  '#767676',
]

const mid_colors = ['#990000', '#137E84', '#946F00', '#CEDEE7', '#732645', '#3A8340', '#0032E6']
const mid_colors_dark = [
  '#BC4D4E',
  '#209AA1',
  '#BC982D',
  '#6590BD',
  '#8D445E',
  '#6B9964',
  '#4866BD',
]

const high_colors = ['#77D2D7', '#FFE185', '#C587A4', '#A2D6A5', '#85A4FF']
const high_colors_dark = ['#A4E1E5', '#FFEBAE', '#D9AFC3', '#C1E4C3', '#AEC2FF']

const low_and_mid_colors = [
  '#CC0000',
  '#990000',
  '#1BB3BC',
  '#137E84',
  '#9E3667',
  '#732645',
  '#9BC3D3',
  '#CEDEE7',
  '#FFCC33',
  '#946F00',
  '#63BA68',
  '#3A8340',
  '#3366FF',
  '#0032E6',
  '#444444',
]
const low_and_mid_colors_dark = [
  '#FF6161',
  '#BC4D4E',
  '#22CFD8',
  '#209AA1',
  '#bc5478',
  '#8D445E',
  '#84C0ff',
  '#6590BD',
  '#FFD684',
  '#BC982D',
  '#8cce80',
  '#6B9964',
  '#5a85ff',
  '#4866BD',
  '#767676',
]

const low_and_mid_and_high_colors = [
  '#CC0000',
  '#990000',
  '#1BB3BC',
  '#137E84',
  '#77D2D7',
  '#9E3667',
  '#732645',
  '#C587A4',
  '#9BC3D3',
  '#CEDEE7',
  '#FFCC33',
  '#946F00',
  '#FFE185',
  '#63BA68',
  '#3A8340',
  '#A2D6A5',
  '#3366FF',
  '#0032E6',
  '#85A4FF',
  '#444444',
]
const low_and_mid_and_high_colors_dark = [
  '#FF6161',
  '#BC4D4E',
  '#22CFD8',
  '#209AA1',
  '#A4E1E5',
  '#bc5478',
  '#8D445E',
  '#D9AFC3',
  '#84C0ff',
  '#6590BD',
  '#FFD684',
  '#BC982D',
  '#FFEBAE',
  '#8cce80',
  '#6B9964',
  '#C1E4C3',
  '#5a85ff',
  '#4866BD',
  '#AEC2FF',
  '#767676',
]

const white = '#f0f0f0'
const skin_background = '#fff0'
const skin_background_dark = '#1f1f1f'

export const PRIMARY_COLOR = [low_colors[0]]
export const PRIMARY_COLOR_DARK = [low_colors_dark[0]]

export const PRIMARY_CAT_SCHEME = ['#ff0000'] // ...low_colors, ...mid_colors, ...high_colors]
export const PRIMARY_CAT_SCHEME_DARK = [...low_colors_dark, ...mid_colors_dark, ...high_colors_dark]

export const PRIMARY_CAT_SCHEME_LOW = ['#ff0000'] // [...low_colors]
export const PRIMARY_CAT_SCHEME_LOW_DARK = [...low_colors_dark]

export const PRIMARY_CAT_SCHEME_MID = ['#ff0000'] // [...low_and_mid_colors]
export const PRIMARY_CAT_SCHEME_MID_DARK = [...low_and_mid_colors_dark]

export const PRIMARY_CAT_SCHEME_HIGH = ['#ff0000'] // [...low_and_mid_and_high_colors]
export const PRIMARY_CAT_SCHEME_HIGH_DARK = [...low_and_mid_and_high_colors_dark]

export const PRIMARY_SEQ3_SCHEME = [white, low_colors[3], low_colors[0]]
export const PRIMARY_SEQ3_SCHEME_DARK = [white, low_colors_dark[3], low_colors_dark[0]]

export const PRIMARY_SEQ2_SCHEME = [custom_colors[3], low_colors[0]]
export const PRIMARY_SEQ2_SCHEME_DARK = [custom_colors[3], low_colors_dark[0]]

export const PRIMARY_BIN_SCHEME = [low_colors[0], low_colors[5]]
export const PRIMARY_BIN_SCHEME_DARK = [low_colors_dark[0], low_colors_dark[5]]

export const CUSTOM_COLORS = custom_colors

export const SKIN_BACKGROUND = skin_background
export const SKIN_BACKGROUND_DARK = skin_background_dark
